module.exports = __webpack_public_path__ + "img/Mr. Mark.5d0ce72d.svg";